// @flow

import * as React from 'react';
import { Flex, Box, useSystem } from 'react-system';
import { useTheme } from '../theme';

type Props = {|
  align: 'left' | 'center' | 'right',
  children: React.Node,
|};

export const SectionHeading = (props: Props): React.Node => {
  const { media, pb } = useSystem();
  const { text, bgColor } = useTheme();

  const alignItems = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };

  return (
    <Flex flexDirection="column" alignItems={alignItems[props.align]}>
      <Box
        mb={[2, 4]}
        width="60px"
        height="4px"
        css={[bgColor('primaryMain'), { borderRadius: '2px' }]}
      />
      <h2
        css={[
          media([text.h6, text.h4]),
          pb(5),
          { textAlign: props.align, maxWidth: '560px' },
        ]}
      >
        {props.children}
      </h2>
    </Flex>
  );
};
